export default ({ schema, uiSchema }) => ({ schema, uiSchema, formData: undefined });



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/Builder/changeQuestionType/toTextArea/fromTable.js